import SpinnerLoadingBlack from "./SpinnerLoadingBlack";

function ConfirmOrCancelDelivery({
  handle,
  message,
  msgType,
  isLoadingEntrega,
  isOrderLoadDelivered,
}) {
  const text = isOrderLoadDelivered
    ? "Cancelar confirmação"
    : "Confirmar entrega";
  return (
    <div className="w-full flex flex-col justify-center items-end mt-4">
      <button
        className={`px-12 py-4 ${
          isOrderLoadDelivered ? "bg-red-500" : "bg-green-500"
        } font-semibold text-base text-white rounded-md text-center`}
        onClick={handle}
      >
        {isLoadingEntrega ? <SpinnerLoadingBlack /> : text}
      </button>
      {message && (
        <p
          className={`pt-4 ${
            msgType === "error" ? "text-red-500" : "text-green-500"
          }`}
        >
          {message}
        </p>
      )}
    </div>
  );
}
export default ConfirmOrCancelDelivery;
